import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';
import { Button } from 'shared/components/Button';
import { ConstellationDivider } from 'shared/components/ConstellationDivider';
import { Eyebrow } from 'shared/components/Eyebrow';
import { Heading } from 'shared/components/Heading';

export interface SubmitLoreModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SubmitLoreModal({ isOpen, onClose }: SubmitLoreModalProps) {
  const { t } = useTranslation('community');

  return (
    <Modal isOpen={isOpen} onClose={onClose} titleId="modal-title">
      <div className="mb-8 pr-8">
        <Heading variant="section" id="modal-title" className="text-on-surface mb-2 md:text-4xl">{t('submitLoreModal.title')}</Heading>
        <p className="text-on-surface-variant italic font-light">
          {t('submitLoreModal.subtitle')}
        </p>
      </div>

      <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Eyebrow as="label" htmlFor="lore-name" className="text-tertiary-fixed-dim font-normal">
              {t('submitLoreModal.nameLabel')}
            </Eyebrow>
            <input
              id="lore-name"
              type="text"
              placeholder={t('submitLoreModal.namePlaceholder')}
              className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all"
            />
          </div>
          <div className="space-y-2">
            <Eyebrow as="label" htmlFor="lore-email" className="text-tertiary-fixed-dim font-normal">
              {t('submitLoreModal.emailLabel')}
            </Eyebrow>
            <input
              id="lore-email"
              type="email"
              placeholder={t('submitLoreModal.emailPlaceholder')}
              className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Eyebrow as="label" htmlFor="lore-story" className="text-tertiary-fixed-dim font-normal">
            {t('submitLoreModal.storyLabel')}
          </Eyebrow>
          <textarea
            id="lore-story"
            rows={6}
            placeholder={t('submitLoreModal.storyPlaceholder')}
            className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all resize-none"
          />
        </div>

        <ConstellationDivider className="justify-center py-4 opacity-30" />

        <div className="flex flex-col md:flex-row justify-end items-center gap-6 pt-4">
          <Button
            variant="link"
            type="button"
            onClick={onClose}
            className="order-2 md:order-1 text-on-surface-variant hover:text-on-surface uppercase tracking-widest"
          >
            {t('submitLoreModal.cancel')}
          </Button>
          <Button variant="gold" size="lg" type="submit" icon="sparkle" iconPosition="right" className="order-1 md:order-2">
            {t('submitLoreModal.submit')}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
